// 九畴云市 · 业务闭环数据（云社员 / 云店 / 供应链 / 服务 / 聚餐 / 权益 / 清分）

// 五项核心技术（华辉数智承担的核心技术交付）
export const coreTechNodes = [
  {
    no: '01',
    title: 'TOMA 智能体',
    subtitle: 'AI 交互入口',
    desc: '美食社交 · 健康管家 · 数字服务',
  },
  {
    no: '02',
    title: '数字货架',
    subtitle: '商品数字化',
    desc: '产品展示 · 交易入口 · 数据回流',
  },
  {
    no: '03',
    title: 'ePin 数字身份',
    subtitle: '一物一码',
    desc: '品质认证 · 数字身份 · 溯源存证',
  },
  {
    no: '04',
    title: '数字消费',
    subtitle: '数字化消费场景',
    desc: '红包 · 权益 · 核销 · 消费数据',
  },
  {
    no: '05',
    title: '智能数据与清分',
    subtitle: '一笔交易，一条数据链',
    desc: '交易记录 · 数据看板 · 智能合约 · 多方协同',
  },
];

// 云社员业务闭环
export const yunSheyuanEntries = [
  {
    icon: 'ri-search-line',
    title: '可寻货 · 省钱',
    desc: '找到好商品，获取优惠，参与消费。',
    points: ['找到好商品', '获取优惠', '参与消费'],
  },
  {
    icon: 'ri-price-tag-3-line',
    title: '可卖货 · 生钱',
    desc: '创建数字货架，分享商品，形成订单，获得相应贡献。',
    points: ['创建数字货架', '分享商品', '形成订单', '获得相应贡献'],
  },
  {
    icon: 'ri-hand-coin-line',
    title: '可服务 · 挣钱',
    desc: '创建服务，接受预约，提供服务，完成评价，获得服务结算。',
    points: ['创建服务', '接受预约', '提供服务', '完成评价', '获得服务结算'],
  },
];

// 云店
export const yunDianFlow = [
  { label: '实体店', detail: '传统实体经营，有商品、有客户、有信任。' },
  { label: '开通云店', detail: '在平台开通数字店铺，获得数字经营能力。' },
  { label: '建立数字货架', detail: '把商品组织成线上可售的数字货架。' },
  { label: '选择供应链商品', detail: '接入供应链，扩充可售商品。' },
  { label: '经营客户', detail: '沉淀客户，建立长期关系。' },
  { label: '线上交易', detail: '线上接单，扩大销售半径。' },
  { label: '线下履约', detail: '线下履约交付，保留实体体验。' },
  { label: '数据沉淀', detail: '经营数据沉淀，反哺经营决策。' },
];

export const yunDianBackend = [
  { icon: 'ri-price-tag-3-line', name: '商品', desc: '商品管理' },
  { icon: 'ri-file-list-3-line', name: '订单', desc: '订单管理' },
  { icon: 'ri-user-heart-line', name: '客户', desc: '客户管理' },
  { icon: 'ri-megaphone-line', name: '营销', desc: '权益营销' },
  { icon: 'ri-bar-chart-line', name: '数据', desc: '经营数据' },
  { icon: 'ri-flow-chart', name: '清分', desc: '贡献结算' },
];

// 供应链
export const supplyFlow = [
  { label: '产地', detail: '农产品源头产地，保障品质与真实。' },
  { label: '供应商', detail: '供应商组织货源，承担商品数字化。' },
  { label: '产品标准化', detail: '产品规格、品质标准化处理。' },
  { label: 'ePin', detail: '赋予商品一物一码数字身份。' },
  { label: '品质认证', detail: '品质认证，建立信任背书。' },
  { label: '数字货架', detail: '商品进入数字货架，可展示可交易。' },
  { label: '云店', detail: '云店接入供应链商品进行分销。' },
  { label: '消费者', detail: '消费者购买，形成真实消费。' },
  { label: '消费数据', detail: '消费数据回流，沉淀真实需求。' },
  { label: '需求反馈', detail: '需求反馈给供应链与生产端。' },
  { label: '生产优化', detail: '生产端按需优化，实现产业闭环。' },
];

// 服务业务
export const serviceFlow = [
  { label: '服务者', detail: '拥有技能的服务提供者。' },
  { label: '创建服务', detail: '在平台发布服务项目与介绍。' },
  { label: '平台审核', detail: '平台审核服务质量与合规性。' },
  { label: '服务上架', detail: '审核通过，服务正式上架。' },
  { label: '用户购买', detail: '用户下单购买服务。' },
  { label: '预约', detail: '预约服务时间与地点。' },
  { label: '服务履约', detail: '服务者提供实际服务。' },
  { label: '用户确认', detail: '用户确认服务完成。' },
  { label: '评价', detail: '用户评价服务，沉淀口碑。' },
  { label: '结算', detail: '平台按规则完成服务结算。' },
];

export const serviceTypes = [
  '餐饮服务',
  '家政服务',
  '本地生活',
  '技能服务',
  '文旅服务',
  '健康服务',
  '农业服务',
  '专业服务',
];

// 聚餐/消费场景
export const partyFlow = [
  { label: '新人权益', detail: '新用户获得聚餐新人权益。' },
  { label: '发起聚餐', detail: '用户发起一场聚餐。' },
  { label: '邀请好友', detail: '邀请好友一起参与。' },
  { label: '选择餐厅', detail: '从平台选择合作餐厅。' },
  { label: '选择套餐', detail: '选择套餐与权益组合。' },
  { label: '到店', detail: '按时到店。' },
  { label: '签到', detail: '到店签到，激活权益。' },
  { label: '消费', detail: '消费结算。' },
  { label: '核销权益', detail: '核销红包、券等权益。' },
  { label: '评价', detail: '评价本次聚餐体验。' },
  { label: '数据回流', detail: '消费数据回流，驱动 AI 分析。' },
];

// 权益系统
export const rightsFlow = [
  { label: '权益产生', detail: '平台/商家/供应链产生消费权益。' },
  { label: '权益领取', detail: '用户领取红包、券等权益。' },
  { label: '权益激活', detail: '满足条件后权益激活。' },
  { label: '分享传播', detail: '权益可分享，形成社交传播。' },
  { label: '到店消费', detail: '到店或线上消费使用权益。' },
  { label: '核销', detail: '权益核销，完成消费抵扣。' },
  { label: '订单', detail: '生成订单记录。' },
  { label: '贡献', detail: '识别推荐、分享等贡献。' },
  { label: '清分', detail: '按规则完成价值清分。' },
];

// 清分系统（透明账本）
export const ledgerRows = [
  { field: '商品', data: '来源' },
  { field: '交易', data: '金额' },
  { field: '用户', data: '消费' },
  { field: '推荐', data: '贡献' },
  { field: '服务', data: '履约' },
  { field: '供应链', data: '供货' },
  { field: '平台', data: '服务' },
  { field: '清分', data: '规则' },
  { field: '对账', data: '结果' },
];

export const settleFlow = [
  { label: '订单', detail: '以订单为清分起点。' },
  { label: '贡献识别', detail: '识别各方贡献主体与比例。' },
  { label: '规则匹配', detail: '匹配清分规则与合约。' },
  { label: '智能计算', detail: '智能计算各方应得金额。' },
  { label: '清分', detail: '执行七方共利清分。' },
  { label: '对账', detail: '对账校验，确保准确。' },
  { label: '异常处理', detail: '处理异常与差错。' },
  { label: '最终结果', detail: '生成最终清分结果。' },
];